import React from 'react';
import * as AlertDialog from '@radix-ui/react-alert-dialog';
import { Info } from 'lucide-react';
import './InfoDialog.css';

interface InfoDialogProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    message: string;
    onContinue?: () => void;
    continueText?: string;
}

const InfoDialog: React.FC<InfoDialogProps> = ({
    isOpen,
    onClose,
    title,
    message,
    onContinue,
    continueText = 'Continue Anyway'
}) => {
    return (
        <AlertDialog.Root open={isOpen} onOpenChange={(open) => !open && onClose()}>
            <AlertDialog.Portal>
                <AlertDialog.Overlay className="info-dialog-overlay" />
                <AlertDialog.Content className="info-dialog-content">
                    <div className="info-dialog-header">
                        <AlertDialog.Title className="info-dialog-title">
                            {title}
                        </AlertDialog.Title>
                    </div>
                    
                    <div className="info-dialog-body">
                        <div className="info-dialog-icon">
                            <Info className="info-icon" />
                        </div>
                        <AlertDialog.Description className="info-dialog-message">
                            {message}
                        </AlertDialog.Description>
                    </div>

                    <div className="info-dialog-footer">
                        {onContinue && (
                            <button
                                onClick={onContinue}
                                className="btn btn-secondary"
                            >
                                {continueText}
                            </button>
                        )}
                        <AlertDialog.Action asChild>
                            <button
                                onClick={onClose}
                                className="btn btn-primary"
                            >
                                OK
                            </button>
                        </AlertDialog.Action>
                    </div>
                </AlertDialog.Content>
            </AlertDialog.Portal>
        </AlertDialog.Root>
    );
};

export default InfoDialog;

